@if (enabled()) {
@if (open()) {
	<div class="chat-panel">
		<div class="chat-header">
			<div class="chat-avatar"><i class="pi pi-sparkles"></i></div>
			<div class="chat-title">
				<div class="chat-title__name">Assistant</div>
				<div class="chat-title__sub">Powered by MiniMax-M3</div>
			</div>
			<button
				type="button"
				class="chat-icon-btn"
				title="New chat"
				(click)="clear()"
			>
				<i class="pi pi-refresh"></i>
			</button>
			<button
				type="button"
				class="chat-icon-btn"
				title="Close"
				(click)="toggle()"
			>
				<i class="pi pi-times"></i>
			</button>
		</div>

		<div class="chat-body">
			@if (empty()) {
				<div class="chat-empty">
					<div class="chat-empty__title">How can I help?</div>
					<div class="chat-empty__text">
						Ask a question and I'll do my best to help.
					</div>
					<div class="chat-suggestions">
						@for (s of suggestions; track s) {
							<button
								type="button"
								class="chat-suggestion"
								(click)="send(s)"
							>
								{{ s }}
							</button>
						}
					</div>
				</div>
			}

			@for (m of messages(); track $index) {
				<div class="chat-row" [class.chat-row--user]="m.role === 'user'">
					<div
						class="chat-bubble"
						[class.chat-bubble--user]="m.role === 'user'"
					>
						{{ m.content }}
					</div>
				</div>
			}

			@if (typing()) {
				<div class="chat-typing">
					<span></span><span></span><span></span>
				</div>
			}
		</div>

		<div class="chat-input">
			<input
				type="text"
				[ngModel]="draft()"
				(ngModelChange)="draft.set($event)"
				(keydown)="onKey($event)"
				placeholder="Ask anything…"
			/>
			<button
				type="button"
				class="chat-send"
				title="Send"
				(click)="send(draft())"
			>
				<i class="pi pi-send"></i>
			</button>
		</div>
	</div>
}

@if (!dismissed()) {
	<div class="chat-pill">
		<div class="chat-pill__main" (click)="toggle()">
			<i [class]="open() ? 'pi pi-chevron-down' : 'pi pi-sparkles'"></i>
			<span>{{ open() ? 'Hide' : 'Ask AI' }}</span>
		</div>
		<div
			class="chat-pill__dismiss"
			title="Hide assistant"
			(click)="dismiss($event)"
		>
			<i class="pi pi-times"></i>
		</div>
	</div>
} @else {
	<div class="chat-restore" title="Show assistant" (click)="restore()">
		<i class="pi pi-sparkles"></i>
	</div>
}
}
